import { AxiosInstance } from "axios"

import type { MyLunchSubscriptionsResponse } from "./subscriptionsTypes"

export enum UserSubscriptionsQuery {
    MY_LUNCH_SUBSCRIPTIONS = "user-my-lunch-subscriptions",
}

export async function fetchMyLunchSubscriptions(
    {},
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<MyLunchSubscriptionsResponse> {
    const { data } = await axios.get<MyLunchSubscriptionsResponse>("/orders/subscriptions/lunch", { signal })
    return data
}
